import { EAbUseExperimentsActions, TAbUseExperimentsActions } from '../../actions/abUseExperiments';
import { IAbExperiment } from '../../types/abUseExperiments';

const initialState: IAbExperiment[] = [];

export function abUseExperimentsReducer(state = initialState, action: TAbUseExperimentsActions): IAbExperiment[] {
  switch (action.type) {
    case EAbUseExperimentsActions.PushExperiments: {
      const experimentsMap = new Map(
        state.concat(action.payload).map(experiment => [experiment.experimentName, experiment]),
      );

      return Array.from(experimentsMap.values());
    }

    default:
      return state;
  }
}
